// JavaScript source code
import React, { useState, useEffect, useRef} from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LoginDialog from '../components/loginDialog';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import { get, getUser, handleImageError } from '../request';
import dataFoot from '../assets/fake-data/data-foot';
import moment from 'moment';
import config from '../config';
function OrderDetail(props) {
    const activeIndex = 5;
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let id = params.get('id');
    const [errorMessage, setErrorMessage] = useState("");
    const navigate  = useNavigate ();
    const [isShowLogin, setIsShowLogin] = useState(false);
    const [isLoading, setShowLoading] = useState(false);
    const [orderdetail, setOrder] = useState({});
    var user = getUser();
    const imageRef = useRef(null); // 创建一个 ref 来引用 img 元素  
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        console.log(user);
        if (user == null || user.userType != 1) {
            setIsShowLogin(true);
            //history.goBack();
        }
        else if (user.business.businessStatus != 0) {
            setErrorMessage("签署正式入驻合同后，可使用我的德联！");
            //history.goBack();
        }
        else {
            fetchData();
        }
    }, [ ]);

    const fetchData = () => {
        if (id) {
            get('delianapi/order/'+id).then((response) => {
                if (response.statusCode !== 200 || response.items.length == 0) {
                    return;
                }
                var order = response.items[0];
                calOrderTotalWeight(order);
                setOrder(order);
            });
        }
        
        //dl.getCart(dl.storage.get('Authorization')).then(function (response) {
        //    if (response.statusCode !== 200) {
        //        alert("请重新登录！");
        //        return;
        //    }
        //    var items = response.items;
        //    items.forEach(function (cart) {
        //        cart.selected = true;
        //    });
        //    $scope.cartlist = items;
        //});

    };

  
    const getColorCss = (statusName) =>{
        if (statusName == '已送达' || statusName == '部分送达') {
            return 'status-green';
        } else if (statusName == '待确认' || statusName == '出库审核' || statusName == '配货中') {
            return 'status-gray';
        } else if (statusName == '已确认' || statusName == '已出库' || statusName == '部分出库' || statusName == '已发货' || statusName == '部分发货') {
            return 'status-blue';
        }
    }

    const calInvoiceTotalWeight = (orderlist) =>{
        for (var i = orderlist.length; i--;) {
            var order = orderlist[i];
            calOrderTotalWeight(order);
        }
    }

    const calOrderTotalWeight =(order)=> {
        var totalWeight = 0;
        order.totalQuantity = 0;
        for (var j = order.orderProductEntityList.length; j--;) {
            var product = order.orderProductEntityList[j];
            if (product.productSkuImageUrl) {
                product.productSkuImageUrl = product.productSkuImageUrl + '.small.png';
            }
            else {
                product.productSkuImageUrl = dataFoot.noimageSmall;
            }
            product.totalWeight = (parseFloat(product.weight) * parseFloat(product.quantity)).toFixed(2);
            totalWeight += parseFloat(product.totalWeight);
            order.totalQuantity += product.quantity;
        }
        order.totalWeight = totalWeight.toFixed(2);
    }
    const handleLoginClick = () => {
        setIsShowLogin(true);
    }
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }

    const returnlist = () => {
        navigate(config.root + "/MyDelian" );
    }
    const handleLocalImageError = (productId, type = 'small') => {
        // 调用公共的handleImageError函数  
        handleImageError(setErrorState, type, productId);
    };
    const setErrorState = (productId, defaultImageUrl) => {
        const oldorderdetail = { ...orderdetail };
        oldorderdetail.orderProductEntityList.forEach(function (product) {
            if (product.id == productId) {
                product.productSkuImageUrl = defaultImageUrl;
                product.error = true;
            }
        });
        setOrder(oldorderdetail);
    };
    return (      
        <div className="mydelian orderDetail" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail" >
                    <div className="detailTitle">
                        <span className="detailNav">
                            我的德联 / <Link to={`${config.root}/MyDelian `} > 我的订单 </Link> /</span>
                        <span className="subtitle">订单详情</span>
                    </div>
                    {
                        screenSize > 991 ? (
                        <div className="myContent">
                            <div className="recordNo">
                                <Link className="back-icon" to={`${config.root}/MyDelian `} ></Link>

                                <span className="orderNo">订单编号： {orderdetail.recordNo}</span>
                                <span className="orderDate">{moment(orderdetail.orderDate).format('YYYY-MM-DD')}</span>
                                <div className="orderStatus">{orderdetail.statusName}</div>
                                <span className="orderDep" >
                                    {orderdetail.erpDepartmentName}
                                </span>
                            </div>
                            <div className="business">
                                <div className="contactName">
                                    <span>{orderdetail.contactName}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span>{orderdetail.contactPhone}</span>
                                </div>
                                <div>
                                    {orderdetail.deliveryAddress}
                                </div>
                                <div>
                                    <span>服务商：</span>
                                    <span>{orderdetail.businessName}</span>
                                </div>
                            </div>
                            {
                                orderdetail.orderOutInStorageList && orderdetail.orderOutInStorageList.length > 0 &&
                                <div className="order-detail-products">
                                    <div className="content-title">物流信息</div>
                                    <div className="integraltable" >
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>出库单号</th>
                                                    <th>发货仓库</th>
                                                    <th>物流公司</th>
                                                    <th>查询电话</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderdetail.orderOutInStorageList.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <span>{item.outInRecordNo}</span>
                                                        </td>
                                                        <td>
                                                            <span className="bold">{item.storehouseName}</span>
                                                        </td>
                                                        <td>
                                                            <span>{item.logisticsCompany}</span>
                                                        </td>
                                                        <td>
                                                            <span className="green bold">{item.logisticsPhone}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                            <div className="order-detail-products">
                                <div className="content-title">产品品信息</div>
                                {
                                    orderdetail.orderProductEntityList &&
                                    orderdetail.orderProductEntityList.map((product, index) => (
                                        <div className="product" key={index}>

                                            <div>
                                                <img className="productImage"
                                                    onError={() => handleLocalImageError(product.id, 'small')} alt=" "
                                                    src={product.productSkuImageUrl} />
                                            </div>
                                            <div className="productName">
                                                <div className="name">
                                                    {product.productSkuName}
                                                </div>
                                                <div className="number">{product.productSkuCode}</div>
                                                <div className="quantity">
                                                    <span className="red bold">
                                                        <small>{product.isPointsDeduction ? '积分' : '￥'}</small>
                                                        <span className="fs-16">
                                                            {product.isPointsDeduction
                                                                ? (product.pointsDeduction / product.quantity).toFixed(2)
                                                                : product.unitPrice}
                                                        </span>
                                                    </span>
                                                    × <span className="bold">{product.quantity}</span>

                                                    <span className="sku"> {product.skuName}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <span className="">总重量：</span>
                                                <span >{(product.weight * product.unQuantity).toFixed(2)}</span> kg
                                            </div>
                                            <div className={getColorCss(product.erpOrderItemStatusName)}>
                                                <div className="red productPrice">
                                                    <small >{product.isPointsDeduction ? '积分' : '￥'}</small>
                                                    <span className="red " >
                                                        {product.isPointsDeduction ? (product.pointsDeduction).toFixed(2) : (product.unitPrice * product.quantity).toFixed(2)}
                                                    </span>
                                                </div>
                                                <div className="status m-r10" >{product.erpOrderItemStatusName}</div>
                                                <div className="info" >
                                                    {
                                                        (product.erpDeliveryDate != null) ?
                                                            ('预计送达时间：' + product.erpDeliveryDateStr) :
                                                            (
                                                                (product.erpExpectedArrivalDate != null) ?
                                                                    ('预计送达时间：' + product.erpExpectedArrivalDateStr) : ''
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className="orderDetailTotal">
                                    <div className="pull-right gray-2">
                                        共计 <span className="red fs-16" >{orderdetail.totalQuantity}</span> 件产品&nbsp;&nbsp;&nbsp;&nbsp;
                                        <span className="">
                                            总重量：
                                        </span>
                                        <span >{orderdetail.totalWeight}</span> kg&nbsp;&nbsp;&nbsp;&nbsp;合计：
                                        <span className="red">￥<span className="totalPrice" >{orderdetail.totalPrice}</span></span>
                                        {
                                            orderdetail.allPointsDeduction > 0 &&
                                            <span className="blue">
                                                &nbsp;&nbsp; 积分：
                                                <span className="totalPrice" >{orderdetail.allPointsDeduction}</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                            </div>) : (
                                <div className="myContent">
                                    <div className="recordNo">
                                        <div className="orderNo">
                                            <div className="recordTitle">订单编号</div>
                                            <div>{orderdetail.recordNo} 
                                            </div>
                                        </div>
                                        <div className="orderDate">
                                            <div className="recordTitle">下单日期</div>
                                            <div>{moment(orderdetail.orderDate).format('YYYY-MM-DD')}</div>
                                        </div>
                                        <div className="orderDep" >
                                            <div className="recordTitle">所属事业部</div>
                                            <div className="blue">{orderdetail.erpDepartmentName}</div>
                                        </div>
                                    </div>
                                    <div className="business">
                                        <div className="businessName">
                                            <span>服务商：</span>
                                            <span>{orderdetail.businessName}</span>
                                        </div>
                                        <div className="contactName">
                                            <span>{orderdetail.contactName}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                            <span>{orderdetail.contactPhone}</span>
                                        </div>
                                        <div>
                                            {orderdetail.deliveryAddress}
                                        </div>
                                       
                                    </div>
                                    <div className="order-detail-products">
                                        {
                                            orderdetail.orderProductEntityList &&
                                            orderdetail.orderProductEntityList.map((product, index) => (
                                                <div className="product" key={index}>
                                                    <div className="imgDiv">
                                                        <img className="productImage"
                                                            onError={() => handleLocalImageError(product.id, 'small')} alt=" "
                                                            src={product.productSkuImageUrl} />
                                                    </div>
                                                    <div className="productName">
                                                        <div className="name">
                                                            {product.productSkuName}
                                                        </div>
                                                        <div className="number">{product.productSkuCode}</div>
                                                        <div className="quantity">
                                                            <div className="red ">
                                                                <small>{product.isPointsDeduction ? '积分' : '￥'}</small>
                                                                <span className="fs-12">
                                                                    {product.isPointsDeduction
                                                                        ? (product.pointsDeduction / product.quantity).toFixed(2)
                                                                        : product.unitPrice}
                                                                </span>
                                                            </div>
                                                            <div className="fs-14">× {product.quantity}</div>
                                                        </div>
                                                        <div className="quantity">
                                                            <div>
                                                                <span className="sku"> {product.skuName}</span>
                                                            </div>
                                                            <div>
                                                                <span className="skuname">总重量：</span>
                                                                <span className="sku">{(product.weight * product.unQuantity).toFixed(2)}kg</span>
                                                            </div>
                                                        </div>
                                                        <div className="price-status">
                                                            <div className="red productPrice">
                                                                <small >{product.isPointsDeduction ? '积分' : '￥'}</small>
                                                                <span className="fs-14 bold " >
                                                                    {product.isPointsDeduction ? (product.pointsDeduction).toFixed(2) : (product.unitPrice * product.quantity).toFixed(2)}
                                                                </span>
                                                            </div>
                                                            <div className="info" >
                                                                <div className={`status ${getColorCss(product.erpOrderItemStatusName)}`} >{product.erpOrderItemStatusName}</div>
                                                                <div className="deliveryDate">
                                                                {
                                                                    (product.erpDeliveryDate != null) ?
                                                                        ('预计送达时间：' + product.erpDeliveryDateStr) :
                                                                        (
                                                                            (product.erpExpectedArrivalDate != null) ?
                                                                                ('预计送达时间：' + product.erpExpectedArrivalDateStr) : ''
                                                                        )
                                                                    }
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>                                                  
                                                   
                                                </div>
                                            ))
                                        }
                                        <div className="orderDetailTotal">
                                            <div className="orderDetailTotalTitle">订单金额</div>
                                            <div className="flex-betwen">
                                                <span className="gray">
                                                    商品件数：
                                                </span>
                                                <span className="fs-14" >{orderdetail.totalQuantity} 件</span>
                                            </div>
                                            <div className="flex-betwen">
                                                <span className="gray">
                                                    总重量：
                                                </span>
                                                <span className="fs-14">{orderdetail.totalWeight} kg</span>
                                            </div>
                                            <div className="flex-betwen">
                                                <span className="">
                                                    合计：
                                                </span>
                                                <span className="red">￥<span className="fs-18 bold" >{orderdetail.totalPrice}</span></span>
                                                {
                                                    orderdetail.allPointsDeduction > 0 &&
                                                    <span className="blue">
                                                        &nbsp;&nbsp; 积分：
                                                        <span className="totalPrice" >{orderdetail.allPointsDeduction}</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        orderdetail.orderOutInStorageList && orderdetail.orderOutInStorageList.length > 0 &&
                                        <div className="order-detail-products">
                                            <div className="content-title">物流信息</div>
                                            <div className="integraltable" >
                                                {orderdetail.orderOutInStorageList.map((item, index) => (
                                                    <div className="wuliu"  key={index}>
                                                        <div className="flex-betwen">
                                                            <span className ="wuliTitle">出库单号</span>
                                                            <span>{item.outInRecordNo}</span>
                                                        </div>
                                                        <div className="flex-betwen">
                                                            <span className="wuliTitle">发货仓库</span>
                                                            <span className="">{item.storehouseName}</span>
                                                        </div>
                                                        <div className="flex-betwen">
                                                            <span className="wuliTitle">物流公司</span>
                                                            <span>{item.logisticsCompany}</span>
                                                        </div>
                                                        <div className="flex-betwen">
                                                            <span className="wuliTitle">查询电话</span>
                                                            <span className="green bold">{item.logisticsPhone}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    }
                                    
                                </div>)
                    }
                    
                </div>
            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
            <MessageDialog message={ errorMessage} onCancel={() => {
                setErrorMessage("");
                navigate(-1);
            }} />            
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
        </div>
          
    );
}

export default OrderDetail;